import { css } from 'styled-components';

const BreakpointWidth = {
  xs: [0, 575],
  sm: [576, 767],
  md: [768, 991],
  lg: [992, 1199],
  xl: [1200, 3999],
};

export const mediaBreakpointUp = (breakpoint, args) => css`
    @media (min-width: ${BreakpointWidth[breakpoint][0]}px) {
      ${css(...args)}
    }
`;

export const mediaBreakpointDown = (breakpoint, args) => `@media (max-width: ${BreakpointWidth[breakpoint][1]}px)`;

export const mediaBreakpointBetween = (breakpointLower, breakpointUpper, args) => css`
    @media (min-width: ${BreakpointWidth[breakpointLower][0]}px) and (max-width: ${BreakpointWidth[breakpointUpper][1]}px) {
      ${css(...args)}
    }
`;